import { Injectable } from '@angular/core';
import { BankCardApiService, CardType } from '@client-monorepo/daily-fintech/bank-card';
import { CardVerifyData } from '../models/card-verify-data';
import { CardVerifyRequest } from '../models/card-verify-request';
import { C2cApiService } from './c2c-api.service';
import { JSEncrypt } from 'jsencrypt';

@Injectable({
  providedIn: 'root',
})
/**
 * The of this class was previously part of the NationalCodeDialog component
 * as obviously this thing have affected the code and required parameters
 */
export class CardVerificationService {
  data!: CardVerifyData;

  constructor(
    private bankCardApiService: BankCardApiService,
    private c2cApiService: C2cApiService,
  ) {}

  public verifyCard(data: CardVerifyData) {
    this.data = data;
    return new Promise((resolve, reject) => {
      this.makeVerifyApiParams()
        .then((request) => {
          this.callVerifyApi(request)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              reject(e);
            });
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  /**
   * Gets the certificate file for encrypting the PAN
   */
  private getCert(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.bankCardApiService.getCertFileByUrl(this.data.cardCheckResponse.cert).subscribe(
        (certText: any) => {
          resolve(certText);
        },
        (e: any) => {
          reject(e);
        },
      );
    });
  }

  /**
   * Makes required object (params) for verification of the card
   */
  private makeVerifyApiParams(): Promise<CardVerifyRequest> {
    return new Promise((resolve, reject) => {
      this.getCert()
        .then((certText) => {
          // src card
          let srcPanValue = '';
          if (!this.data.srcCard.cardIndex) {
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(certText);
            const srcPan = this.data.srcCard.pan?.replace(/-/gi, '') || '';
            srcPanValue = encrypt.encrypt(srcPan) as string;
          } else {
            srcPanValue = this.data.srcCard.cardIndex;
          }

          // dest card
          let destPanValue = '';
          if (!this.data.destCard.cardIndex) {
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(certText);
            const destPan = this.data.destCard.pan?.replace(/-/gi, '') || '';
            destPanValue = encrypt.encrypt(destPan) as string;
          } else {
            destPanValue = this.data.destCard.cardIndex;
          }

          const request = {
            nationalCode: this.data.nationalCode,
            pan: {
              postfix: this.data.srcCard.postfix,
              prefix: this.data.srcCard.prefix,
              type: this.data.srcCard.cardIndex ? CardType.INDEX : CardType.ENCRYPTED,
              value: srcPanValue,
            },
            targetPan: {
              postfix: this.data.destCard.postfix,
              prefix: this.data.destCard.prefix,
              type: this.data.destCard.cardIndex ? CardType.INDEX : CardType.ENCRYPTED,
              value: destPanValue,
            },
          } as CardVerifyRequest;

          if (this.data.amount) {
            request.amount = this.data.amount;
          }

          resolve(request);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  /**
   * Calls Verify API
   * @param requestParams
   */
  protected callVerifyApi(requestParams: CardVerifyRequest) {
    return new Promise((resolve, reject) => {
      this.c2cApiService.verifyCardApi(requestParams).subscribe(
        (response) => {
          resolve(response);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }
}
